import api from "../../utils/apiUser";

export const getMetodosEnvio = async () => {
  const res = await api.get("/api/metodos_envio");
  return res.data;
};

export const crearMetodoEnvio = async (data) => {
  const res = await api.post("/api/metodos_envio", data);
  return res.data;
};

export const actualizarMetodoEnvio = async (id, data) => {
  const res = await api.put(`/api/metodos_envio/${id}`, data);
  return res.data;
};
